<template>
  <div class="main_building">
    <div class="building_fields" >
        <div class="card_b" :class="{active: expntionBoxs.includes('basic_details')}">
        <div class="head">
            <h3>נתונים בסיסיים</h3>
            <div class="arrow_headers">
            <div class="icon" @click="toggleBox('basic_details')" :class="expntionBoxs.includes('basic_details') ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
            </div>
        </div>
        <div class="content" v-if="item">
            <div class="galery_fields_container">
            <div class="fields_container">
                <ul>
                    <li class="label_input">
                        <label>כתובת הפרויקט</label>
                        <!-- <input type="text" v-model="item.address"> -->

                        <googleInput @update="updateAddress" :data="{district:item.district , city:item.city ,street:item.street ,num_building:item.num_building ,full_address:item.full_address ,google_place_id:item.google_place_id}"  />
                        <!-- :placeId="'ChIJTZ77xS9KHRUR6mpI0govodA'"  -->
                        <span class="helper_text">ישמש כשם הפרויקט</span>
                    </li>
                    <li class="label_input">
                        <label>הערה</label>
                        <input type="email" v-model="item.note">
                        <!-- <span class="helper_text">כדי שנוכל לשלוח לך אישור הרשמה</span> -->
                    </li>
                </ul>
                <div class="gray_bg radius properties_add_container">
                <div class="properties_container">
                    <div class="property_container" v-for="(property, i) in item.properties" :key="property.id">
                    <div class="trash_continer" v-if="i > 0" @click="deleteProperty(i)">
                        <div class="icon trash_icon"></div>
                    </div>
                    <li class="label_input">
                        <label>סוג נכס</label>
                        <select v-model="property.type">
                            <option value="">בחירה מתוך הרשימה</option>
                            <option v-for="(list,i) in $store.prop_types" :key="i" :value="list.id" v-text="list.name"></option>
                        </select>
                    </li>
                    <li class="label_input">
                        <label>מס' יחידות הקיימות בסוג זה</label>
                        <input type="number" min="0" v-model="property.count">
                    </li>
                    </div>
                </div>
                <div class="add_property_container">
                    <!-- item.properties.length < $store.prop_types.length &&  -->
                    <div class="btn_b text_s" @click="item.properties.push({type: '', num: 0, id: uniqueId()})">
                    <span>הוספת סוג נכס</span>
                    <span class="icon plus_icon"></span>
                    </div>
                </div>
                </div>
            </div>
            <div class="galery_cntainer">
                <p>תמונות מהבניין 
                (אופציונאלי)</p>
                <span>ניתן להעלות עד 5 תמונות לבניין</span>
                <GalleryInput  v-model="item.gallary" :max="5" />	
            </div>
            </div>
        </div>
        </div>

        <div class="card_b legal_details" :class="{active: expntionBoxs.includes('legal_details')}">
            <div class="head">
                <h3>נתונים משפטיים</h3>
                <div class="arrow_headers">
                    <div class="icon" @click="toggleBox('legal_details')" :class="expntionBoxs.includes('legal_details') ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
                </div>
            </div>
            <div class="content">
                <div class="fields_notes_container">
                    <div class="fields_container">
                        <li class="label_input">
                        <label>גוש</label>
                        <input type="text" v-model="item.gosh">
                        <!-- <span class="helper_text">ישמש כשם הפרויקט</span> -->
                        </li>
                        <li class="label_input">
                        <label>חלקה</label>
                        <input type="text" v-model="item.helka">
                        <!-- <span class="helper_text">ישמש כשם הפרויקט</span> -->
                        </li>
                        
                        
                        <li class="label_input">
                            <label class="text">האם קיימת הפקעה?</label>
                            <!-- <div class="switch_container">
                                <span>לא</span>
                                <div class="onoffswitch">
                                    <input type="checkbox" v-model="item.is_hafkaa"  name="onoffswitch-a" :id="id" class="onoffswitch-checkbox"  tabindex="0">
                                    <label :for="id" class="onoffswitch-label"></label>
                                </div>
                                <span>כן</span>
                            </div> -->
                            <div class="theme-switch-wrapper mid">
                                <span>כן</span>
                                <label class="theme-switch" :for="id">
                                    <input v-model="item.is_hafkaa" type="checkbox"  :id="id" />
                                    <div class="slider round"></div>
                                </label>
                                <span>לא</span>
                            </div>
                        </li>
                        <li class="label_input">
                        <label class="text">האם רשום כבית משותף?</label>
                        <!-- <div class="switch_container">
                            <span>לא</span>
                            <div class="onoffswitch">
                                <input type="checkbox" v-model="item.is_join_house"  name="onoffswitch-b" :id="id+'a'" class="onoffswitch-checkbox"  tabindex="0">
                                <label :for="id+'a'" class="onoffswitch-label"></label>
                            </div>
                            <span>כן</span>
                        </div> -->
                            <div class="theme-switch-wrapper mid">
                                <span>כן</span>
                                <label class="theme-switch" :for="id + 'a'">
                                    <input v-model="item.is_join_house" type="checkbox"  :id="id + 'a'" />
                                    <div class="slider round"></div>
                                </label>
                                <span>לא</span>
                            </div>
                        </li>
                    </div>
                    <div class="notes_more_fields_btn_container">
                        <div class="notes_more_fields" :style="(!item.is_join_house ? 'min-width:90%' : '')">
                            <template v-if="item.is_join_house">
                                <div class="notes">במקרה כזה, יש להעלות את המסמכים הרלוונטים. אם הם לא ברשותך, ניתן להוריד אותם כאן</div>
                                <div class="more_fields">
                                    <li>
                                        <label>צו רישום בית משותף</label>
                                        <GalleryInput  v-model="item.join_house_file_1" />	
                                    </li>
                                    <li>
                                        <label>תקנון בית משותף</label>
                                        <GalleryInput  v-model="item.join_house_file_2" />	
                                    </li>
                                    <li>
                                        <label>תשריט בית משותף</label>
                                        <GalleryInput  v-model="item.join_house_file_3" />	
                                    </li>
                                </div>
                            </template>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="card_b details_planes" :class="{active: expntionBoxs.includes('details_planes')}">
            <div class="head">
                <h3>נתונים תכנוניים</h3>
                <div class="arrow_headers">
                <div class="icon" @click="toggleBox('details_planes', id)" :class="expntionBoxs.includes('details_planes') ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
                </div>
            </div>
            <div class="content">
                <div class="notes_fields_container">
                <div class="fields_container">
                    <div class="must_filds">
                        <li class="label_input" >
                            <label>היתר בנייה מילולי</label> 
                            <GalleryInput  v-model="item.main_permet_file" />	
                        </li>
                        <li class="label_input">
                            <label>גרמושקה</label>
                            <GalleryInput  v-model="item.gar_file" />	
                        </li>
                        <li class="label_input">
                            <label>מס’ הקומות (כולל קרקע)</label>
                            <input type="number" min="0" v-model="item.floors_count" @change="floors_open=false">
                            <!-- <span class="helper_text">ישמש כשם הפרויקט</span> -->
                        </li>
                        <li class="label_input">
                            <label>שטח החלקה (מ"ר)</label>
                            <input type="text" v-model="item.helka_property">
                            <!-- <span class="helper_text">ישמש כשם הפרויקט</span> -->
                        </li>
                    </div>
                </div>
                <div class="notes">
                    <p>אם ההיתרים הנ”ל לא ברשותך, ניתן להוריד אותם מהאתר של מחלקת ההנדסה של הרשות הרלוונטית.</p>
                </div>
                </div>
                <div class="btn_container">
                    <div class="btn_b text_s fit" :class="floors_open ? 'disabled' : ''" @click="saveData">המשך</div>
                </div>
            </div>
        </div>
        
        
        
        <template v-if="item.floors && item.floors.length > 0 && floors_open">
            <template v-for="(floor,i) in item.floors" :key="i">
                <Floor @update="floor = $event" :floorComp="floor" />
            </template>
        </template>

    </div>

    <div class="sum_continue_btn">
        <div class="sum_container">
            <ul>
                <li class="end_line">
                    <span> סיכום בניין {{item.numbuildingNum}} </span>
                </li>

                <li>
                    <span>{{n_70_year_old_plus}}  קשיש (גילאי 70+)</span>
                </li>
                <li>
                    <span>{{n_75_year_old_plus}}  קשיש מעל גיל 75</span>
                </li>
                <li>
                    <span>{{patient_likely_die}}  חולה נוטה למות</span>
                </li>
                <li>
                    <span>{{disability_peoples}}  מעוטי יכולת</span>
                </li>
                
                <li>
                    <span>{{sum_garden}}  דירות גן</span>
                </li>
                <li>
                    <span>{{sum_roof}}  דירות גג</span>
                </li>
                
                <li>
                    <span>{{item.floors.length}}  קומות</span>
                </li>
                <li class="end_line">
                    <span>{{num_apartments}}  יחידות</span>
                </li>
                <!-- <li>
                    <span>מתוכן:</span>
                </li>
                <li>
                    <span>4  עם משכנתא</span>
                </li>
                <li>
                    <span>4  עם משכנתא</span>
                </li>
                <li>
                    <span>4  עם משכנתא</span>
                </li> -->
            </ul>
        </div>
        <div class="btn_container">
            <div class="btn" @click="$emit('save',item)">המשך לשלב הבא</div>
        </div>
    </div>

</div>
</template>

<script>
import Floor from './floor.vue'
import GalleryInput from '../GalleryInput.vue';
import googleInput from '@/components/googleInput.vue'

export default {    
    props:{
        itemComp:{
            type: Object,
            required: true
        },
        token:{
            type: String,
            default: '',
            required: true
        }
    },
    components: {Floor,GalleryInput,googleInput},
    data() {
        return {
          id: this.random_id(),
          item:[],
          floors_open: false,
          address_form: {
            district: '',
            city: '',
            street: '',
            num_building: '',
            full_address: ''
          },
          expntionBoxs: [
            'basic_details',
            'details_planes',
            'legal_details'
          ],
          floors: [],
        }
    },
    beforeMount(){
        this.item = this.itemComp;
    },
    computed: {
        num_apartments() {
            let num = 0;
            if(this.item.floors && this.item.floors.length > 0)
            {
                this.item.floors.forEach(floor => {
                    num += +floor.apartments_num;
                });
            }
            return num;
        },
        n_70_year_old_plus() {
            return this.get_count_data_apartments('70_year_old_plus');
        },
        n_75_year_old_plus() {
            return this.get_count_data_apartments('75_year_old_plus');
        },
        patient_likely_die() {
            return this.get_count_data_apartments('patient_likely_die');
        },
        disability_peoples() {
            return this.get_count_data_apartments('disability_peoples');
        },
        sum_roof() {
            return this.get_count_data_apartments('apartment_type', id => id == 2127 ? 1 : 0);
        },
        sum_garden() {
            return this.get_count_data_apartments('apartment_type', id => id == 2128 ? 1 : 0);
        }

    },
    watch: {
        item: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    },
    methods: {
        
        get_count_data_apartments(key, calcNum = num => num) {
            let num = 0;
            if(this.item.floors && this.item.floors.length > 0)
            {
                this.item.floors.forEach(floor => {
                    floor.apartments.forEach(apartment => {
                        num += calcNum(isNaN(+apartment[key]) ? 0 : +apartment[key]);
                    });
                });
            }
            return num;
        },
        updateAddress(data)
        {
            this.item.district = data.district;
            this.item.city = data.city;
            this.item.street = data.street;
            this.item.num_building = data.num_building;
            this.item.full_address = data.full_address;
            this.item.google_place_id = data.google_place_id;
        },
        saveData(){
            if(this.item.floors_count > 0 && this.item.floors.length == 0)
            {
                for (let i = 0; i < this.item.floors_count; i++)
                {
                    this.addFloor(i+1);
                }
            }
            else if(this.item.floors_count > 0 && this.item.floors.length > 0)
            {
                if(this.item.floors_count > this.item.floors.length)
                {
                for (let i = this.item.floors.length; i < this.item.floors_count; i++)
                {
                    this.addFloor(i+1);
                }
                }
                else if(this.item.floors_count < this.item.floors.length)
                {
                this.item.floors = this.item.floors.slice(0, this.item.floors_count);
                }
            }
            
            setTimeout(() => {
                this.floors_open = true;
            }, 100);
        },
        addFloor(floor_num=0){
            let floor = {
                apartments_open: false,
                apartments_num: 0,
                floor_num,
                apartments: [ ]
            };
            this.item.floors.push(floor);
        },
        random_id() {
            // This function generates a string of 10 random characters
            // You can adjust the length by changing the number 10
            return Math.random().toString(36).substring(2, 12);
        },
        save(){
             
             
        },
         handleUpload(data,type) {
            console.log(data, type, this.item.main_permet_file);
            if (data && data.id) {
                switch(type){
                    case 'main_permet_file':{
                        this.item.main_permet_file = data.id;
                        break;
                    }
                    case 'gar_file':{
                        this.item.gar_file = data.id;
                        break;
                    }
                    case 'join_house_file_1':{
                        this.item.join_house_file_1 = data.id;
                        break;
                    }
                    case 'join_house_file_2':{
                        this.item.join_house_file_2 = data.id;
                        break;
                    }
                    case 'join_house_file_3':{
                        this.item.join_house_file_3 = data.id;
                        break;
                    }
                }
            }
        },
        toggleBox(boxName) {
            if (this.expntionBoxs.includes(boxName)) this.expntionBoxs = this.expntionBoxs.filter( str => str != boxName)
            else this.expntionBoxs.push(boxName)
        },
        deleteProperty(propertyId) {
                if (propertyId !== -1) {
                    this.item.properties.splice(propertyId, 1);
                }
        }
    }
}
</script>

<style lang="scss">
.main_building { display: flex; flex-direction: column; gap: var(--gap_xbig);}
.building_fields {display: flex; flex-direction: column; gap: var(--gap_mid);}
    .fields_container {
        li { flex: 1;
            .text { text-align: center;}
        }
    }
    .galery_fields_container {display: flex; justify-content: space-between; gap: var(--gap_big);
        .fields_container { flex:9; display: flex; flex-direction: column; gap: var(--gap_big); 
          >ul {display: flex; gap: var(--gap_xbig);
            li { 
                &:first-child { flex: 3;}
                &:last-child { flex: 4;}
            }
          }
          .properties_add_container { display: flex; justify-content: space-between; padding: 16px 24px; gap: var(--gap);
            .properties_container {display: flex; flex-direction: column; gap: var(--gap_mid);
              .property_container {display: flex; gap: 32px; position: relative; padding-left: calc(var(--gap) + var(--fieldHeight));
                .trash_continer { position: absolute; bottom: 0; left: 0; display: flex; align-items: center; justify-content: center; height: var(--fieldHeight); width: var(--fieldHeight); background: var(--pageBG); border-radius: 8px; cursor: pointer; }
              }
            }
            .add_property_container {
              >div { display: flex; align-items: center; cursor: pointer;margin-top: 13px;
                span {color: var(--title_color);}
              }
            }
          } 
        }
        .galery_cntainer {flex: 4; display: flex; flex-direction: column;
            p, span {text-align: center;}
            span {text-align: center; margin-bottom: var(--gap);}
        }
      }
      .details_planes {
        .notes_fields_container { display: flex; flex-direction: column; gap: 32px; 
          .fields_container { display: flex; gap: calc( var(--gap_xbig) * 2); 
            >div {display: flex; gap: var(--gap_big); 
              li {flex: 1;    overflow: hidden;}
            } 
            .must_filds { flex: 2;    overflow: hidden; position: relative;  
              &::after { content: ''; position: absolute; left: calc(var(--gap_xbig) * -1); top: 0; bottom: 0; width: 1px; background: var(--pageBG);}
            }
            .more_fields { flex: 3; }
          }
          .notes { color: var(--dark_blue); width: 30%;}
        }
        .btn_container { margin-right: auto; max-width: fit-content; }
      }
      .legal_details {
        .fields_notes_container { display: flex; flex-direction: column;gap: var(--gap_big); 
          .fields_container {display: flex; gap: var(--gap_big);}
          .notes_more_fields_btn_container { display: flex; align-items: flex-end; flex: 3;
            .notes_more_fields { display: flex; gap: var(--gap_big);
              .more_fields { display: flex; gap: var(--gap_big); flex: 6;}
              .notes { color: var(--dark_blue);  flex: 3;}
            }
          }
          .btn_container { flex: 1; max-width: fit-content; margin-right: auto; }
        }
      }

.sum_continue_btn { display: flex; align-items: stretch; justify-content: space-between; background: #f5f9fa; padding: 24px 32px;border-radius: var(--radius);
    .sum_container {
        ul { display: flex; align-items: center; gap: var(--gap_xmid); height: 100%;
            li { display: flex; align-items: center; height: 100%;
                &.end_line {position: relative;  padding-left: var(--gap_xmid);
                    &::after { content: ''; position: absolute; top: 0; bottom: 0; width: 1px; left: 0; background: #E7F0F3;}
                }
                span { color: var(--dark_blue); font-size: var(--h5);}
            }
        }
    }
    .btn_container {
        // .btn {padding-inline: 10px;}
    }
}
</style>